'use strict';

const $ = require('jquery');

class Menu {

    constructor() {

        this.desktopMenu();
        this.mobileMenu();

        let $keyVisual = $('.key-visual-home, .key-visual.large, .vacancy-details');

        if ($keyVisual.length > 0) {

            const KeyVisualHeight = $keyVisual.height();
            const headerHeight = $('#header').height();

            App.Globals.$window.on('load scroll', () => {

                let windowTop = App.Globals.$window.scrollTop();

                if ((windowTop + headerHeight) >= KeyVisualHeight) {
                    App.Globals.body.classList.add('scrolled');
                } else {
                    App.Globals.body.classList.remove('scrolled');
                }
            });
        }
    }

    desktopMenu() {

        let $menuItem = $('.menu-header [data-sub-menu]');

        $menuItem.on('mouseover', (event) => {

            this.closeDesktopMenu();

            let $target = $(event.target);
            let id = $target.data('sub-menu');

            $target.addClass('active');

            App.Globals.$body.addClass('sub-menu-open');
            $(`#sub-menu-${id}`).addClass('active');
        });

        $('.sub-menu').on('mouseleave', () => {

            this.closeDesktopMenu();
        });

        //  Hover on submenu items with images
        let $subMenuItem = $('[data-image-hover]');
        let $imageHolder = $('[data-image-hover-holder]');

        $subMenuItem
            .on('mouseover', (event) => {

                let currentTarget = event.currentTarget;
                let imageSrc = currentTarget.dataset.imageHover;

                $imageHolder
                    .attr('src', imageSrc)
                    .addClass('active');
            })
            .on('mouseleave', () => {

                $imageHolder
                    .attr('src', '')
                    .removeClass('active');
            });

    }

    closeDesktopMenu() {

        App.Globals.$body.removeClass('sub-menu-open');
        $('.sub-menu').removeClass('active');
        $('.menu-header [data-sub-menu]').removeClass('active');

    }

    mobileMenu() {

        let mobileMenu = document.querySelectorAll('.menu-mobile');

        if (mobileMenu.length > 0) {

            require('./../../../../build/node_modules/@components/mmenu/dist/mmenu.js');
            require('./../../../../build/node_modules/@components/mmenu/dist/mmenu.polyfills.js');

            new Mmenu('.menu-mobile', {
                    offCanvas: false,
                }
            );

        }

    }

}

module.exports = Menu;
